// extracted by mini-css-extract-plugin
export default {"root":"TcAH0fio","button":"m2SwmLRS"};